/**
 * Collapsible question and answer blocks.
 */

import { queryAll } from "../core/dom";

const OPEN_CLASS = "is-open";

/** Toggle the accordion owning `trigger` and return its new state. */
export function toggleAccordion(trigger: HTMLElement): boolean {
    const accordion = trigger.closest<HTMLElement>(".accordion");
    if (!accordion) {
        return false;
    }

    const open = !accordion.classList.contains(OPEN_CLASS);
    accordion.classList.toggle(OPEN_CLASS, open);
    trigger.setAttribute("aria-expanded", open ? "true" : "false");

    return open;
}

/** Wire every accordion trigger present on the page. */
export function initAccordions(): void {
    for (const trigger of queryAll<HTMLElement>("[data-accordion]")) {
        trigger.setAttribute("aria-expanded", "false");
        trigger.addEventListener("click", () => toggleAccordion(trigger));
    }
}
